// extracted by mini-css-extract-plugin
export default {"nav":"Header_nav__iMfyh","divHeader":"Header_divHeader__wayum","userDetailsContainer":"Header_userDetailsContainer__HTwSt","divsvg":"Header_divsvg__aJepa"};